/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from 'react';
import './WhyJoinComponent.scss';

const WhyJoinComponent = (props: any) => {
  const [participants, setParticipants] = useState({ num: 0 });
  const [lecturer, setLecturer] = useState({ num: 0 });
  const [theme, setTheme] = useState({ num: 0 });

  const counterParticipants = useRef(0);
  const counterLecturer = useRef(0);
  const counterTheme = useRef(0);

  useEffect(() => {
    if (!props.start) return;
    if (counterParticipants.current < 1400) {
      counterParticipants.current += 1;
      const timer = setTimeout(() => setParticipants({ num: participants.num + 1 }), 1);
      return () => clearTimeout(timer);
    }
  }, [props.start, participants]);

  useEffect(() => {
    if (!props.start) return;

    if (counterLecturer.current < 135) {
      counterLecturer.current += 1;
      const lecturerTimer = setTimeout(() => setLecturer({ num: lecturer.num + 1 }), 28);
      return () => clearTimeout(lecturerTimer);
    }
  }, [props.start, lecturer]);

  useEffect(() => {
    if (!props.start) return;

    if (counterTheme.current < 135) {
      counterTheme.current += 1;
      const lecturerTimer = setTimeout(() => setTheme({ num: theme.num + 1 }), 28);
      return () => clearTimeout(lecturerTimer);
    }
  }, [props.start, theme]);

  return (
    <div className="main-container">
      <p className="title">ZAŠTO NAM SE PRIDRUŽITI?</p>
      <p className="text">
        Udruženje osiguravača Srbije organizuje konferenciju "DOT" koja okuplja vodeće kompanije i
        ljude Informatičke struke iz Srbije, regiona i šire. Odabirom tema i predavača, DOT daje
        odgovore na najvažnija pitanja industrije osiguranja koja se tiču informacionih tehnologija
        u širokoj prizmi koja se kreće sve od IT bezbednosti i infrastrukturnih rešenja pa do
        najnaprednijih softvera za primenu u svakodnevnim poslovima osiguranja i do primene veštačke
        inteligencije. Na ovaj način doprinosimo daljem razvoju osiguranja, bržem i lakšem
        prilagođavanju standardima razvijenih tržišta i novim potrebama korisnika usluga osiguranja
        koje su sve češće i u sve većem obimu direktno vezane za digitalizaciju i IT.
      </p>
      <div className="data-box">
        <div className="single-box">
          <p className="number">{participants.num}+</p>
          <p className="single-box-text">učesnika</p>
        </div>
        <div className="single-box">
          <p className="number">{lecturer.num}+</p>
          <p className="single-box-text">predavača</p>
        </div>
        <div className="single-box">
          <p className="number">{theme.num}+</p>
          <p className="single-box-text">tema</p>
        </div>
      </div>
    </div>
  );
};

export default WhyJoinComponent;
